"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importStar(require("styled-components"));
exports.keyframes = styled_components_1.keyframes;
exports.css = styled_components_1.css;
exports.injectGlobal = styled_components_1.injectGlobal;
exports.ThemeProvider = styled_components_1.ThemeProvider;
var dom_elements_1 = __importDefault(require("./_helpers/dom-elements"));
var styled_margin_1 = __importDefault(require("./_helpers/styled-margin"));
var styledWithHelpers = function (styledComponent) { return styled_components_1.default(styledComponent); };
dom_elements_1.default.forEach(function (domElement) {
    styledWithHelpers[domElement] = function (styles) {
        var interpolations = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            interpolations[_i - 1] = arguments[_i];
        }
        interpolations.push(styled_margin_1.default);
        return styled_components_1.default[domElement].apply(styled_components_1.default, __spread([styles], interpolations));
    };
    styledWithHelpers[domElement].withConfig = styled_components_1.default[domElement].withConfig;
    styledWithHelpers[domElement].attrs = styled_components_1.default[domElement].attrs;
});
exports.default = styledWithHelpers;
//# sourceMappingURL=styled.js.map